import { webAnalytics as wa } from '@principal/web-analytics';
import BasicSearchOption from '../../models/BasicSearchOption';
import { SearchType, TabType } from '../../../shared/models/WebAnalytics';

interface BasicSearchOptionsProps {
  basicSearchOptions: BasicSearchOption[];
  currentOption: BasicSearchOption;
  setCurrentOption: (option: BasicSearchOption) => void;
}

const BasicSearchOptions = (props: BasicSearchOptionsProps) => {
  const { basicSearchOptions, currentOption, setCurrentOption } = props;

  const createOnClick = (option: BasicSearchOption) => (event: React.MouseEvent) => {
    event.preventDefault();
    setCurrentOption(option);
    wa.trackEvent('pageNavigationClick', {
      clicktext: `${TabType.EARNINGS}-${SearchType.BASIC_SEARCH}-Option-${option.label}`,
      navigationsection: 'tab',
    });
  };

  return (
    <div>
      {basicSearchOptions && (
        <div>
          <div>
            <label>I want to see:</label>
          </div>
          <div className="btn-group" role="group">
            {basicSearchOptions.map((option) => (
              <button
                key={option.key}
                type="button"
                title={option.tooltipText}
                className={option.key === currentOption.key ? 'btn btn-default selected' : 'btn btn-default'}
                onClick={createOnClick(option)}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BasicSearchOptions;
